import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentModal from '../../CommentModal';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import VerificationPopup from '../../VerificationPopup';
import VerificationSuccessfulPopup from '../../VerificationSuccessfulPopup';
import BackgroundPickerPopup from '../../DeviationBackground/BackgroundPickerPopup';
import UserBlockPopup from '../../Moderation/UserBlockPopup';
import { DesktopSharePopup, MobileDeviationSharePopup, MobileSharePopup } from '../../SharePopup';
import LoadableDeviationGroupListPopup from '../../DeviationGroupListPopup/LoadableDeviationGroupListPopup';
import MobileChatPanelModal from '../../Chat/ChatPanel/MobileChatPanelModal/LoadableMobileChatPanelModal';
import MobileChatWindowModal from '../../Chat/ChatWindow/MobileChatWindowModal/LoadableMobileChatWindowModal';
import MobileNewChatWindow from '../../Chat/ChatWindow/MobileNewChatWindow/LoadableMobileNewChatWindow';
import UserSymbolsPopup from '../../UserSymbolsPopup';
import GlobalConfirmationModal from '../../Popup/ConfirmationModal/GlobalConfirmationModal';
import GlobalConfirmationModalForMM from '../../MediaPopup/_partials/GlobalConfirmationModalForMM';
import AwardsPopup from '../../coreBadge/CoreBadgeButton/AwardsPopup';
import AwardBadgeModal from '../../coreBadge/AwardBadgeModal';
import { ModalType } from '../redux/types';
import CompletionPopup from '../../CompletionPopup';
import GiveLlamaPopup from '../../GiveLlamaPopup';
import GroupClosedWatchModal from '../../GroupModals/GroupClosedWatchModal';
import GroupJoinPendingModal from '../../GroupModals/GroupJoinPendingModal';
import FavouritedByModal from '../../FavouritedByModal';
import DeviantsListModal from '../../DeviantsList/DeviantsListModal';
import TierUnsubscribePopup from '../../Tier/UnsubscribePopup';
import TierUnsubscribeByUsernamePopup from '../../Tier/UnsubscribePopup/UnsubscribeByUsernamePopup';
import TierChangePopup from '../../Tier/ChangeTierPopup';
import AddToGroupPopup from '../../ActionBar/_partials/AddToGroupPopup';
import LoadingScreenModal from '../../LoadingScreenModal';
import ReportPage from '../../ReportPage';
import ConnectSuccessModalLoadable from '../../Discord/ConnectSuccessModal/ConnectSuccessModalLoadable';
import DisconnectModalLoadable from '../../Discord/DisconnectModal/DisconnectModalLoadable';
import BadgeInfoModalLoadable from '../../Badge/BadgeInfoPopover/Modal/ModalLoadable';
import LoadableMobileNotesPanel from '../../SiteHeader/_partials/NotesButtonAndDropdown/MobileNotesPanel/LoadableMobileNotesPanel';
import ContentFilterSettingsModal from '../../ContentFilterSettingsModal';
import AISuppressionSettingsModal from '../../AISuppressionSettingsModal';
import BirthdayPopup from '../../BirthdayPopup';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import SafeUrlModal from '../../SafeUrlModal';
const NonContentModals = (props)=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { modalType, popModal: doPopModal, params } = props;
    const popModal = useCallback(()=>{
        yieldToMain(()=>{
            doPopModal();
        });
    }, [
        doPopModal
    ]);
    switch(modalType){
        case ModalType.GIVE_BADGE:
            return /*#__PURE__*/ React.createElement(GiveLlamaPopup, {
                username: params.username,
                onBadgeSent: params.onBadgeSent,
                onModalClose: params.onClose
            });
        case ModalType.GIVE_ITEM_FAILURE:
            return /*#__PURE__*/ React.createElement(CompletionPopup, {
                imageWidth: 89,
                imageHeight: 133,
                image: "https://st.deviantart.net/eclipse/popups/give-popups/llama.svg",
                title: t(params.titleLocaleKey || 'common.oops'),
                message: params.errorDescription
            });
        case ModalType.COMMENT_THREAD:
            return /*#__PURE__*/ React.createElement(CommentModal, {
                isOpen: true,
                typeid: params.typeId,
                itemid: params.itemId,
                commentid: params.commentId,
                parentComment: params.parentComment
            });
        case ModalType.CONFIRMATION:
            return /*#__PURE__*/ React.createElement(ConfirmationModal, {
                isOpen: true,
                title: params.title,
                text: params.text,
                icon: params.icon,
                variant: params.variant,
                cancelBtnLabel: params.cancelBtnLabel,
                cancelBtnBiData: params.cancelBtnBiData,
                confirmBtnLabel: params.confirmBtnLabel,
                confirmBtnType: params.confirmBtnType,
                confirmBtnBiData: params.confirmBtnBiData,
                withCancelButton: params.withCancelButton,
                useTransparentOverlay: params.useTransparentOverlay,
                onCancel: ()=>{
                    popModal();
                    params.onCancel && params.onCancel();
                },
                onConfirm: ()=>{
                    popModal();
                    params.onConfirm && params.onConfirm();
                },
                doNotShowAgainKey: params.doNotShowAgainKey
            });
        case ModalType.GLOBAL_CONFIRMATION:
        case ModalType.GLOBAL_CONFIRMATION_FOR_MM:
            const PopupComponent = modalType === ModalType.GLOBAL_CONFIRMATION ? GlobalConfirmationModal : GlobalConfirmationModalForMM;
            const TextComponent = params.textComponent;
            const text = TextComponent ? /*#__PURE__*/ React.createElement(TextComponent, null) : typeof params.textTransKey === 'string' ? t(params.textTransKey, params.translationOptions) : params.textTransKey;
            return /*#__PURE__*/ React.createElement(PopupComponent, {
                isOpen: true,
                closeOnConfirmation: params.closeOnConfirmation,
                title: t(params.titleTransKey, params.translationOptions),
                text: text,
                variant: params.variant,
                icon: params.icon,
                withCancelButton: params.withCancelButton,
                cancelBtnLabel: t(params.cancelBtnLabelTransKey, params.translationOptions),
                cancelBtnBiData: params.cancelBtnBiData,
                confirmBtnLabel: t(params.confirmBtnLabelTransKey, params.translationOptions),
                confirmBtnType: params.confirmBtnType,
                confirmBtnBiData: params.confirmBtnBiData,
                onCancel: params.onCancel,
                onConfirm: params.onConfirm,
                doNotShowAgainKey: params.doNotShowAgainKey,
                onRequestClose: params.onRequestClose && (()=>{
                    popModal();
                    params.onRequestClose();
                })
            });
        case ModalType.VERIFICATION:
            return /*#__PURE__*/ React.createElement(VerificationPopup, {
                actionType: params.actionType,
                onClose: popModal
            });
        case ModalType.VERIFICATION_SUCCESSFUL:
            return /*#__PURE__*/ React.createElement(VerificationSuccessfulPopup, null);
        case ModalType.DEVIATION_BACKGROUND_PICKER:
            return /*#__PURE__*/ React.createElement(BackgroundPickerPopup, {
                deviation: params.deviation,
                requestClose: popModal
            });
        case ModalType.REPORT_DEVIATION_MODAL:
            return /*#__PURE__*/ React.createElement(ReportPage, {
                deviationId: params.deviationId,
                requestClose: popModal
            });
        case ModalType.BIRTHDAYS:
            return /*#__PURE__*/ React.createElement(BirthdayPopup, {
                requestClose: popModal
            });
        case ModalType.USER_BLOCK:
            return /*#__PURE__*/ React.createElement(UserBlockPopup, {
                user: params.user,
                redirectLocation: params.redirectLocation,
                requestClose: popModal
            });
        case ModalType.MOBILE_DEVIATION_SHARE:
            return /*#__PURE__*/ React.createElement(MobileDeviationSharePopup, {
                deviation: params.deviation,
                requestClose: popModal
            });
        case ModalType.SHARE_LINK:
            return isMobile ? /*#__PURE__*/ React.createElement(MobileSharePopup, {
                url: params.url,
                title: params.title,
                requestClose: popModal
            }) : /*#__PURE__*/ React.createElement(DesktopSharePopup, {
                url: params.url,
                title: params.title,
                requestClose: popModal
            });
        case ModalType.MOBILE_SHARE:
            return /*#__PURE__*/ React.createElement(MobileSharePopup, {
                url: params.url,
                title: params.title,
                requestClose: popModal
            });
        case ModalType.MOBILE_NOTES_DRAWER:
            return /*#__PURE__*/ React.createElement(LoadableMobileNotesPanel, {
                onClose: popModal
            });
        case ModalType.DEVIATION_GROUP_LIST:
            return /*#__PURE__*/ React.createElement(LoadableDeviationGroupListPopup, _object_spread_props(_object_spread({}, params), {
                requestClose: popModal
            }));
        case ModalType.ADD_TO_GROUP:
            return /*#__PURE__*/ React.createElement(AddToGroupPopup, _object_spread_props(_object_spread({}, params), {
                forceModal: true,
                onClose: popModal
            }));
        case ModalType.MOBILE_CHAT_LIST:
            return /*#__PURE__*/ React.createElement(MobileChatPanelModal, {
                isOpen: true
            });
        case ModalType.MOBILE_CHAT_WINDOW:
            return /*#__PURE__*/ React.createElement(MobileChatWindowModal, {
                isOpen: true,
                chatId: params.chatId
            });
        case ModalType.MOBILE_CHAT_WINDOW_NEW:
            return /*#__PURE__*/ React.createElement(MobileNewChatWindow, {
                isOpen: true
            });
        case ModalType.USER_SYMBOLS_LEGEND:
            return /*#__PURE__*/ React.createElement(UserSymbolsPopup, {
                requestClose: popModal
            });
        case ModalType.RECEIVED_AWARDS:
            return /*#__PURE__*/ React.createElement(AwardsPopup, {
                recipient: params.recipient,
                typeId: params.typeId,
                itemId: params.itemId,
                badges: params.badges,
                defaultActiveType: params.defaultActiveType,
                requestClose: popModal
            });
        case ModalType.AWARD_BADGE:
            return /*#__PURE__*/ React.createElement(AwardBadgeModal, {
                requestClose: popModal,
                isOpen: true,
                recipient: params.recipient,
                typeId: params.typeId,
                itemId: params.itemId
            });
        case ModalType.GROUP_CLOSED_WATCH:
            return /*#__PURE__*/ React.createElement(GroupClosedWatchModal, {
                popModal: popModal,
                group: params.group
            });
        case ModalType.GROUP_JOIN_PENDING:
            return /*#__PURE__*/ React.createElement(GroupJoinPendingModal, {
                popModal: popModal,
                group: params.group
            });
        case ModalType.FAVOURITED_BY:
            return /*#__PURE__*/ React.createElement(FavouritedByModal, {
                deviationId: params.deviationId,
                typeId: params.typeId,
                requestClose: popModal
            });
        case ModalType.DEVIANTS_LIST:
            return /*#__PURE__*/ React.createElement(DeviantsListModal, {
                selectedUserId: params.selectedUserId,
                onItemClick: params.onItemClick,
                requestClose: popModal
            });
        case ModalType.TIER_UNSUBSCRIBE:
            return /*#__PURE__*/ React.createElement(TierUnsubscribePopup, {
                deviation: params.tier,
                close: popModal
            });
        case ModalType.TIER_UNSUBSCRIBE_BY_USERNAME:
            return /*#__PURE__*/ React.createElement(TierUnsubscribeByUsernamePopup, {
                username: params.username,
                close: popModal
            });
        case ModalType.TIER_CHANGE:
            return /*#__PURE__*/ React.createElement(TierChangePopup, {
                currentTier: params.currentTier,
                newTier: params.newTier,
                isDowngrade: params.isDowngrade,
                close: popModal
            });
        case ModalType.LOADING_SCREEN:
            return /*#__PURE__*/ React.createElement(LoadingScreenModal, null);
        case ModalType.DISCORD_CONNECT_SUCCESS:
            return /*#__PURE__*/ React.createElement(ConnectSuccessModalLoadable, {
                guildId: params.guildId,
                requestClose: popModal
            });
        case ModalType.DISCORD_DISCONNECT:
            return /*#__PURE__*/ React.createElement(DisconnectModalLoadable, {
                requestClose: popModal
            });
        case ModalType.BADGE_INFO:
            return /*#__PURE__*/ React.createElement(BadgeInfoModalLoadable, {
                username: params.username,
                badgeId: params.badgeId,
                onClose: popModal
            });
        case ModalType.CONTENT_FILTER_SETTINGS:
            return /*#__PURE__*/ React.createElement(ContentFilterSettingsModal, _object_spread({
                requestClose: popModal
            }, params));
        case ModalType.AI_SUPPRESSION_SETTINGS:
            return /*#__PURE__*/ React.createElement(AISuppressionSettingsModal, _object_spread({
                requestClose: popModal
            }, params));
        case ModalType.SAFE_URL:
            return /*#__PURE__*/ React.createElement(SafeUrlModal, _object_spread({
                requestClose: popModal
            }, params));
        default:
    }
    return null;
};
NonContentModals.displayName = 'NonContentModals';
export default NonContentModals;

//# sourceMappingURL=NonContentModals.js.map